import React, { useState } from 'react';
import ReactModal from 'react-modal';
import SuccessInfo from './SuccessInfo';
import { useDispatch, useSelector } from 'react-redux';
import {
  getInfoVisibleState,
  getNewUserIdState,
  hideInfo,
} from '../../Reducers/RegisterInfoReducer';
import { resendConfirmationEmail } from '../../../Register/Utils/ApiCall';

const RegisterInfoModal: React.FunctionComponent = (): React.ReactElement => {
  const [isLoading, setIsLoading] = useState(false);

  const modalStyle = {
    content: {
      borderRadius: '10px',
    },
  };
  const visible = useSelector(getInfoVisibleState);
  const newUserId = useSelector(getNewUserIdState);
  const dispatch = useDispatch();

  const handleResendConfirmationEmail = async (): Promise<void> => {
    if (newUserId && !isLoading) {
      try {
        setIsLoading(true);
        await resendConfirmationEmail(newUserId);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div>
      <ReactModal
        isOpen={visible}
        style={modalStyle}
        className="alert-modal-content"
        overlayClassName="alert-modal-overlay"
      >
        <SuccessInfo
          onClose={() => {
            dispatch(hideInfo());
            window.location.replace('/login');
          }}
          onResendEmail={handleResendConfirmationEmail}
          newUserId={newUserId}
        />
      </ReactModal>
    </div>
  );
};

export default RegisterInfoModal;
